import React from 'react';
import GoogleMapViewComparative from '../GoogleMapViewComparative';
import { Box } from '@mui/material';
import {
  TMapProps,
  popupMapOptions,
} from '../../../../types/mvpMap';

const MapOnDialogView = (props: TMapProps) => {
  return (
    <Box sx={{ width: '100%', height: '70vh' }}>
      <GoogleMapViewComparative
        {...props}
        options={popupMapOptions}
      />
    </Box>
  );
};

export default MapOnDialogView;
